import React, { ErrorInfo, ReactElement } from 'react';

interface ErrorHandlerProps {
  error: Error;
}

type ErrorHandler = ( props: ErrorHandlerProps ) => ReactElement;

interface ErrorBoundaryProps {
  /** Renders when an error occurs. Receives { error: Error } as props. */
  ErrorView: ErrorHandler;
  /** If given, errors caught will have this heading in console.error. */
  logHeading?: string;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state: { error: any };

  constructor( props: ErrorBoundaryProps ) {
    super( props );
    this.state = { error: null };
  }

  static getDerivedStateFromError( error: any ) {
    return { error };
  }

  componentDidCatch( error: Error, info: ErrorInfo ) {
    console.error(
      `%c%s\n\n## Error\n%c%s\n\n%c## Stack%c%s`,
      'font-weight: bold',
      this.props.logHeading,
      'font-weight: normal',
      error,
      'font-weight: bold',
      'font-weight: normal',
      info.componentStack,
    );
  }

  render() {
    const { ErrorView } = this.props;
    return this.state.error ? <ErrorView error={ this.state.error } /> : this.props.children;
  }
}
